import { asc, eq } from 'drizzle-orm'
import { db } from '@/db'
import { users, tenantMemberships } from '@/db/schema'
import { getI18nForUserId } from '@/lib/i18n/server'
import { requireExpertUser } from '@/lib/role-guard'
import UsersClient from './UsersClient'

export default async function AdminUsersPage() {
  const expert = await requireExpertUser()
  const i18n = await getI18nForUserId(expert.id)
  const t = i18n.t

  const rows = await db
    .select({
      id: users.id,
      email: users.email,
      displayName: users.displayName,
      role: tenantMemberships.role,
      isActive: tenantMemberships.isActive,
      authProvider: users.authProvider,
      preferredLanguage: users.preferredLanguage,
      lastLoginAt: users.lastLoginAt,
      createdAt: users.createdAt,
    })
    .from(users)
    .innerJoin(tenantMemberships, eq(tenantMemberships.userId, users.id))
    .where(eq(tenantMemberships.tenantId, expert.tenantId))
    .orderBy(asc(users.email))

  const serialized = rows.map((r) => ({
    ...r,
    lastLoginAt: r.lastLoginAt?.toISOString() ?? null,
    createdAt: r.createdAt.toISOString(),
  }))

  return (
    <main className="min-h-screen bg-zinc-50 px-4 py-10 text-zinc-950 dark:bg-zinc-950 dark:text-zinc-100">
      <div className="mx-auto max-w-3xl space-y-6">
        <div>
          <h1 className="text-2xl font-semibold text-zinc-950 dark:text-white">{t('adminUsers.title')}</h1>
          <p className="mt-1 text-sm text-zinc-600 dark:text-zinc-400">
            {t('adminUsers.intro')}
          </p>
        </div>
        <UsersClient
          initialUsers={serialized}
          currentUserId={expert.id}
          labels={{
            inviteTitle: t('adminUsers.inviteTitle'),
            email: t('adminUsers.email'),
            role: t('adminUsers.role'),
            language: t('adminUsers.language'),
            addUser: t('adminUsers.addUser'),
            adding: t('adminUsers.adding'),
            failedInvite: t('adminUsers.failedInvite'),
            inviteSuccess: t('adminUsers.inviteSuccess'),
            activeMembers: t('adminUsers.activeMembers'),
            countFiltered: t('adminUsers.countFiltered'),
            filterPlaceholder: t('adminUsers.filterPlaceholder'),
            disabled: t('adminUsers.disabled'),
            none: t('adminUsers.none'),
            member: t('adminUsers.member'),
            lastLogin: t('adminUsers.lastLogin'),
            actions: t('adminUsers.actions'),
            you: t('adminUsers.you'),
            never: t('adminUsers.never'),
            disable: t('adminUsers.disable'),
            reEnable: t('adminUsers.reEnable'),
            actionFailed: t('adminUsers.actionFailed'),
            roleHelp: t('adminUsers.roleHelp'),
            activeHelp: t('adminUsers.activeHelp'),
            roles: {
              line_manager: t('roles.line_manager'),
              expert: t('roles.expert'),
              admin: t('roles.admin'),
            },
          }}
        />
      </div>
    </main>
  )
}
